import { Config } from 'containers/AppContainer/typings';
import { get } from 'lodash';

export const getRejectionReasons = (
  rejectionReasonsListing: Config[],
  rejectionReasons: { rejectionReasonId: number }[],
) => {
  return rejectionReasons.map(elem =>
    get(
      rejectionReasonsListing?.find(val => val?.id === elem?.rejectionReasonId),
      'title',
      '',
    ),
  );
};
